// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FeaturedArtistsSection from "./FeaturedArtistsSection.re.mjs";
import * as RescriptRelay_Fragment from "rescript-relay/src/RescriptRelay_Fragment.re.mjs";
import * as RescriptRelay_TestFragmentRef from "rescript-relay/src/RescriptRelay_TestFragmentRef.re.mjs";
import * as HomeFeaturedArtists_query_graphql from "../../../__generated__/HomeFeaturedArtists_query_graphql.re.mjs";

let convertFragment = HomeFeaturedArtists_query_graphql.Internal.convertFragment;

function fromData(data) {
  return RescriptRelay_TestFragmentRef.make("HomeFeaturedArtists_query", data);
}

let Test = {
  fromData: fromData
};

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, HomeFeaturedArtists_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(HomeFeaturedArtists_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, HomeFeaturedArtists_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(HomeFeaturedArtists_query_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  Test: Test,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function HomeFeaturedArtists(props) {
  let data = RescriptRelay_Fragment.useFragment(HomeFeaturedArtists_query_graphql.node, convertFragment, props.query);
  let artists = data.featuredArtists.filter(artist => Stdlib_Option.isSome(artist.sampleImage)).map(artist => ({
    id: artist.id,
    name: Stdlib_Option.getOr(Stdlib_Option.orElse(artist.name, artist.displayName), ""),
    username: Stdlib_Option.getOr(artist.username, ""),
    country: artist.country,
    sampleImage: artist.sampleImage
  }));
  return JsxRuntime.jsx(FeaturedArtistsSection.make, {
    artists: artists
  });
}

let make = HomeFeaturedArtists;

export {
  Fragment,
  make,
}
/* react/jsx-runtime Not a pure module */
